import { observable, action, runInAction, computed, toJS } from 'mobx';
import service from '@service/index';
import fetchUrl from '@service/fetchUrl';

import login_user_store from '@store/LoginUser/LoginUserStore';

import ChartType from './ChartTypeEnum';

class Store {
  /**
   * 个人信息
   */
  @observable
  myInfo = {};

  @computed
  get rate() {
    let result;
    if( isNaN(this.myInfo.radio * 100) ) {
      result = 0.00;
    } else {
      result = (Number(toJS(this.myInfo.radio))).mul(100).toFixed(2);
    }
    return result;
  }

  /**
   * 下线信息
   */
  @observable
  nextCountInfo = {};
  /**
   * 提现
   * @type {[]}
   */
  @observable
  sumBackMoney = [];
  /**
   * 线上充值
   * @type {[]}
   */
  @observable
  sumOnPayment = [];
  /**
   * 线下充值
   * @type {[]}
   */
  @observable
  sumOffPayment = [];
  /**
   * 总投注
   */
  @observable
  sumOrderMoney = [];

  /**
   * 团队用户
   */
  @observable
  teamActiveUsers = [];

  /**
   * 代理赠送
   */
  @observable
  teamAgentGift = [];

  /**
   * 返佣
   *  总足球篮球返佣(串关)
   */
  @observable
  teamCommission = [];

  /**
   * 返佣
   * 总足球篮球返佣(单关)
   *
   */
  @observable
  teamCommissiondg = [];

  /**
   * 返佣
   * 总其他游戏返佣
   */
  @observable
  teamCommissionqt = [];

    /**
   * 会员赠送
   */
    @observable
    teamHasLottery = [];
    @observable
    teamHasWinning = [];
    @observable
    teamNewUser = [];
    @observable
    teamNotLottery = [];
    @observable
    transferChargeFree = [];
    @observable
    Arr = [];
    @observable
    Arr1 = [];
    @observable
    teamNumOffAgents = [];
    @observable
    teamNumOffMembers = [];
    @observable
    teamNumRecharge = [];
    @observable
    teamNumWithdrawals = [];
    @observable
    teamPresentMembers = [];
    @observable
    teamRechargingGift = [];

  /**
   *总返佣
   *
   */
  @observable
  teamCommissionData =0
  // 统计首页
  async fetchHomePageData( uid,type_time='6' ) {
    this.myInfo = {};
    this.nextCountInfo = {};
    // this.backMoney = [];
    // this.countActiveUser = [];
    // this.countNewUser = [];
    // this.orderMoney = [];
    // this.payment = [];
    // this.proxyAmount = [];


    let url = fetchUrl.pandect.teamStatist;
    let result = await service.fetchData({
      path: url,
      params: {
        uid: uid,
        flag:2,
        type_time:type_time
      }
    });
    if( result.success ) {
      let Arr = []
      let Arr1 = []
      let result_data = result.data;
      runInAction(() => {
        for(let k in result_data){
          if(k == 'teamNewUser' || k == 'teamNumOffAgents' ||  k == 'teamNumOffMembers' ||  k == 'teamNumRecharge'  ||  k == 'teamNumWithdrawals'  ||  k == 'teamActiveUsers'){
            Arr1.push(result_data[k][0])
          }else if(k != 'teamSumRecharge' && k != 'teamHasWinning' && k != 'teamHasLottery'){
            Arr.push(result_data[k][0])
          }
        }
        // this.myInfo = result_data.myInfo;
        // this.nextCountInfo = result_data.nextCountInfo;
        this.teamCommission     = result_data.teamCommission
        this.teamCommissiondg   = result_data.teamCommissiondg
        this.teamCommissionqt   = result_data.teamCommissionqt
        let proxyTeamComVal= Number(this.teamCommission[0]['data']) + Number(this.teamCommissiondg[0]['data']) + Number(this.teamCommissionqt[0]['data'])
        this.teamCommissionData     = proxyTeamComVal.toFixed(2)
        // console.log(proxyTeamComVal)
        // Arr.push({
        //   data:proxyTeamComVal,
        //   name:'返佣'
        // })
        this.sumBackMoney = result_data.sumBackMoney
        this.sumOffPayment = result_data.sumOffPayment
        this.sumOnPayment = result_data.sumOnPayment
        this.sumOrderMoney = result_data.sumOrderMoney
        this.teamActiveUsers = result_data.teamActiveUsers
        this.teamAgentGift = result_data.teamAgentGift

        this.Arr = Arr
        this.Arr1 = Arr1
        this.teamHasLottery = result_data.teamHasLottery
        this.teamHasWinning = result_data.teamHasWinning
        this.teamNewUser = result_data.teamNewUser
        this.teamNotLottery = result_data.teamNotLottery

        this.teamNumOffAgents = result_data.teamNumOffAgents
        this.teamNumOffMembers = result_data.teamNumOffMembers
        this.teamNumRecharge = result_data.teamNumRecharge
        this.teamNumWithdrawals = result_data.teamNumWithdrawals
        this.teamPresentMembers = result_data.teamPresentMembers
        this.teamRechargingGift = result_data.teamRechargingGift
      })
    } else {

    }
  }

  /**
    * 今日统计（包含前6日）
    * @param type 类型 :
    *  1.充值统计       payment
    *  2.提现统计       backMoney
    *  3.投注金额统计    orderMoney
    *  4.返佣金额统计    proxyAmount
    *  5.新增会员统计    countNewUser
    *  6.活跃用户统计    countActiveUser
    * @param status 返回前台页面传1
   */
  async fetchTodayData( type, uid ) {
    let url = fetchUrl.pandect.countToday;
    let result = await service.fetchData({
      path: url,
      params: {
        uid: uid,
        flag: false,
        type: ChartType[ type ],
        status: 1
      }
    });
    if( result.success ) {
      // console.log('countToday: ', result.data);
      result.data.reverse();
      runInAction(() => {
        // this[type] = result.data;
      });
      return result;
    } else {

    }
  }
}

let my_summary_store = new Store();

export default my_summary_store;



// WEBPACK FOOTER //
// ./src/Store/Pandect/MySummary/MySummaryStore1.js